import React from 'react';

import DEIPageCounter from '../../DEIPageCounter/DEIPageCounter';

import {
  DEIPageBarChartBarDIV,
  DEIPageBarChartBarWrapperDIV,
  DEIPageBarChartBarBarDIV,
} from './DEIPageBarChartBar.styles';

const DEIPageBarChartBar = ({
  color,
  percentage,
  title,
  width, // Width in %
}) => {
  const isNA = percentage === 'N/A';
  return (
    <DEIPageBarChartBarDIV
      style={{
        width: `${width > 25 ? 25 : width}%`,
      }}
    >
      <DEIPageBarChartBarWrapperDIV>
        <strong className="type--headline-medium-L">{
          isNA ?
            (
              <span>{percentage}</span>
            ) :
            (
              <span>
                <DEIPageCounter value={percentage} />%
              </span>
            )
        }</strong>
        <DEIPageBarChartBarBarDIV
          style={{
            height: `${isNA ? 0 : Number(percentage) / 100 * 300}px`,
            background: `bottom center url(${color.PATTERN_M}) ${color.HEX}`,
          }}
        />
      </DEIPageBarChartBarWrapperDIV>
      <h4 className="font--text-M">{title}</h4>
    </DEIPageBarChartBarDIV>
  );
}

export default DEIPageBarChartBar;
